import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import glamorous from 'glamorous'
import content from 'pp-react-l10n'
import { track3DS2PageImpression } from '../../utils/3ds-utils'
import { trackLinkWithData } from '../../../lib/analytics/fpti'
let i18n = content('transfer/inc/selectedFundingOption')

const Iframe = glamorous.iframe({
  width: '100%',
  height: '650',
  margin: '0 auto',
  display: 'block',
  border: 0,
})

/**
 * This component renders a challenge URL in Iframe for 3DS2.0 Challenge Use Case
 */
export class ThreeDS2ChallengeIframe extends React.Component {
  static propTypes = {
    show: PropTypes.bool,
    challengeRedirectLink: PropTypes.string,
    challengeRedirectMethod: PropTypes.string,
    jwt: PropTypes.string,
    selectedFundingOption: PropTypes.shape({
      id: PropTypes.string,
    }),
    dispatch: PropTypes.func.isRequired,
    handle3DS2Success: PropTypes.func.isRequired,
    handle3DS2Failure: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.formRef = React.createRef()
    this.analyticsStrings = {
      pageGroup: 'main:p2p:cards::3DS-challenge',
      pageName: 'main:p2p:cards::3DS-challenge::',
    }
  }

  componentDidUpdate(prevProps) {
    const { show: nextShow } = this.props
    const { show: prevShow } = prevProps
    if (prevShow === true && prevShow !== nextShow) {
      // If overpanel is closed, we want to remove event listener
      window.removeEventListener('message', this.cardinalChallengeListener)
    }
  }

  componentDidMount() {
    const { pageGroup = '', pageName = '' } = this.analyticsStrings
    const { selectedFundingOption = {} } = this.props
    track3DS2PageImpression(pageGroup, pageName, selectedFundingOption)

    if (this.formRef.current) {
      this.formRef.current.submit()
    }

    // To prevent adding multiple listeners
    if (this.hasAdded3DSListener) {
      return null
    }

    /**
     * Challenge Screen is rendered by cardinal on the iframe and after user clicks submit/cancel
     * Cardinal comes back to the return url of p2p (/auth-contingency)
     * P2P calls resolve contingency and in turn posts the response to
     */
    window.addEventListener('message', this.cardinalChallengeListener)
    this.hasAdded3DSListener = true
  }

  componentWillUnmount() {
    // Remove listener on unmount since we add listener when mounted
    window.removeEventListener('message', this.cardinalChallengeListener)
  }

  cardinalChallengeListener = event => {
    const {
      threeDS2ConfirmationStatus = '',
      err = '',
      threeDS2Contingency = '',
    } = event.data
    if (threeDS2ConfirmationStatus) {
      let analyticsData = {
        resp_duration: {
          challenge_start_time: new Date().getTime(),
        },
      }
      const { pageGroup = '', pageName = '' } = this.analyticsStrings
      // track analytics data
      analyticsData.challenge_status = threeDS2ConfirmationStatus
      analyticsData.challenge_shown = true
      analyticsData.resp_duration.challenge_end_time = new Date().getTime()
      trackLinkWithData(
        'Challenge Response',
        pageGroup,
        pageName,
        analyticsData
      )
      // handle success and failure cases post challenge
      if (threeDS2ConfirmationStatus === 'threeDS-failure') {
        this.props.handle3DS2Failure(err)
      } else if (threeDS2ConfirmationStatus === 'threeDS-success') {
        this.props.handle3DS2Success(event, {
          threeDS2Contingency,
        })
      }
    }
  }

  render() {
    if (!this.props.show) {
      return null
    }
    const {
      challengeRedirectLink = '',
      challengeRedirectMethod = '',
      jwt = '',
    } = this.props

    return (
      <div>
        <Iframe
          title={i18n('a11y.3ds.iframe.title')}
          name="setupUp"
          id="stepUp"
        >
          <form
            ref={this.formRef}
            name="stepup"
            target="setupUp"
            method={challengeRedirectMethod}
            action={challengeRedirectLink}
          >
            <input type="hidden" name="JWT" value={jwt} />

            <input type="hidden" name="MD" value="" />
          </form>
        </Iframe>
      </div>
    )
  }
}

export default connect(({ transaction, overpanels }) => ({
  show: overpanels.showThreeDS2ChallengeIframe,
  challengeRedirectLink: transaction.challengeRedirectLink,
  challengeRedirectMethod: transaction.challengeRedirectMethod,
  jwt: transaction.challengeJWT,
  selectedFundingOption: transaction.selectedFundingOption,
}))(ThreeDS2ChallengeIframe)
